import { alpha, Box, Typography, useTheme } from "@mui/material";

interface IForubusSignatureFieldsRowProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  mono?: boolean;
  accent?: boolean;
}

export const ForubusSignatureFieldsRow: React.FC<
  IForubusSignatureFieldsRowProps
> = ({ icon, label, value, mono, accent }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        py: 1.25,
        px: 2,
        borderRadius: 1,
        transition: "background 0.15s",
        "&:hover": {
          background: alpha(theme.palette.primary.main, 0.06),
        },
      }}
    >
      <Box
        sx={{
          mt: 0.15,
          color: accent
            ? theme.palette.secondary.main
            : theme.palette.primary.main,
          opacity: 0.8,
          flexShrink: 0,
          display: "flex",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: "0.62rem",
            display: "block",
            mb: 0.2,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: mono
              ? "'Fira Code', 'Cascadia Code', monospace"
              : "inherit",
            fontSize: mono ? "0.76rem" : "0.875rem",
            color:
              !value || value === "—"
                ? theme.palette.text.disabled
                : theme.palette.text.primary,
            wordBreak: "break-all",
            lineHeight: 1.5,
          }}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Box>
  );
};
